import React from "react"

function RewardsTab() {
  const rewards = [
    { id: 1, name: "Early Adopter", description: "Joined during the platform launch", icon: "🚀" },
    { id: 2, name: "High Roller", description: "Made a single transaction over $10,000", icon: "💰" },
    { id: 3, name: "Diverse Portfolio", description: "Holds more than 5 different cryptocurrencies", icon: "🌈" },
  ]

  return (
    <div className="bg-white shadow overflow-hidden sm:rounded-lg">
      <div className="px-4 py-5 sm:px-6">
        <h3 className="text-lg leading-6 font-medium text-gray-900">Rewards</h3>
        <p className="mt-1 max-w-2xl text-sm text-gray-500">Your earned badges and rewards</p>
      </div>
      <div className="border-t border-gray-200">
        <ul className="divide-y divide-gray-200">
          {rewards.map((reward) => (
            <li key={reward.id} className="px-4 py-4 sm:px-6">
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <div className="flex-shrink-0 h-12 w-12 bg-indigo-100 rounded-full flex items-center justify-center text-2xl">
                    {reward.icon}
                  </div>
                  <div className="ml-4">
                    <div className="text-sm font-medium text-indigo-600">{reward.name}</div>
                    <div className="text-sm text-gray-500">{reward.description}</div>
                  </div>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}

export default RewardsTab

